export const OPEN_CONTRACT_ACTION: string = 'openContract';
